import { useState } from 'react';
import { Shell } from '../../components/layout/Shell.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { CollerListe } from '../../components/CollerListe.jsx';
import { Inp, inpFS } from '../../components/ui/Inputs.jsx';
import { BAT_PRESETS } from '../../constants/trades';
import { DEVISE, fmt } from '../../lib/currency';
import { METIER_RULES, detectMetier } from '../../lib/discounts';
import { tr, trf } from '../../lib/i18n';
import { UNITS_LIST } from '../../lib/packaging';
import { C } from '../../theme/palette';

export function ArticlesBatimentPage({
  onNav,
  soc,
  catalogue,
  setCatalogue,
  estMixte,
  univers,
  setUnivers,
}) {
  const [show, setShow] = useState(false);
  const [presetMet, setPresetMet] = useState('');
  const [selMet, setSelMet] = useState('');
  const [q, setQ] = useState('');
  const [f, setF] = useState({ metier: '', nom: '', u: '', p: '', sd: '' });
  const [editId, setEditId] = useState(null);
  const [ef, setEf] = useState({ metier: '', nom: '', u: '', p: 0, sd: '' });
  const arts = catalogue || [];
  const ql = q.trim().toLowerCase();
  const filtered = ql
    ? arts.filter(
        (a) =>
          (a.metier || '').toLowerCase().includes(ql) || (a.nom || '').toLowerCase().includes(ql),
      )
    : arts;
  const metiersAll = [...new Set(filtered.map((a) => a.metier || 'Autres'))];
  const metierChips = [
    ...METIER_RULES.map((r) => r[0]),
    ...metiersAll.filter((m) => !METIER_RULES.some((r) => r[0] === m)),
  ];
  const metiers = selMet ? metiersAll.filter((m) => m === selMet) : metiersAll;
  const add = () => {
    const id =
      'A' + (arts.reduce((m, a) => Math.max(m, +String(a.id).replace(/\D/g, '') || 0), 0) + 1);
    setCatalogue &&
      setCatalogue((p) => [
        ...p,
        {
          id,
          metier: f.metier || detectMetier(f.nom) || 'À classer',
          nom: f.nom,
          u: f.u || 'forfait',
          p: +f.p || 0,
          sd: f.sd || '',
          codeCan: (f.codeCan || '').trim(),
        },
      ]);
    setF({ metier: '', nom: '', u: '', p: '', sd: '', codeCan: '' });
    setShow(false);
  };
  return (
    <Shell
      active="plus"
      onNav={onNav}
      soc={soc}
      pageTitle="➕ Ajouter un article"
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      <div
        style={{
          background: C.navyXL,
          border: '1px solid ' + C.navyL,
          borderRadius: 10,
          padding: '9px 12px',
          fontSize: 8.5,
          color: C.grey,
          marginBottom: 11,
          lineHeight: 1.5,
        }}
      >
        Tes articles enregistrés. Ils apparaissent dans la recherche quand tu crées un devis ou une
        facture.
      </div>
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="🔎 Rechercher un métier, une prestation"
        style={inpFS}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
        <Btn
          label={show ? 'Fermer' : '+ Ajouter un article'}
          sm
          color={C.navy}
          onClick={() => setShow((s) => !s)}
        />
      </div>
      {/* Plusieurs articles d'un coup, collés depuis les Notes, Word ou Excel,
          comme dans l'offre : un article au même nom prend le nouveau prix. */}
      <CollerListe
        choix={[
          ['ht', 'Prix de vente (hors TVA)'],
          ['ttc', 'Prix public (TVA comprise)'],
        ]}
        libelleAjout={tr('✓ Ajouter à mes articles')}
        onAjoute={(lues) => {
          if (!setCatalogue) return;
          let n = arts.reduce((m, a) => Math.max(m, +String(a.id).replace(/\D/g, '') || 0), 0);
          const cle = (x) =>
            String(x || '')
              .trim()
              .toLowerCase();
          setCatalogue((p) => {
            const suite = [...p];
            for (const l of lues) {
              const deja = suite.findIndex((a) => cle(a.nom) === cle(l.d));
              if (deja >= 0) {
                suite[deja] = {
                  ...suite[deja],
                  u: l.u || suite[deja].u,
                  p: l.p || suite[deja].p,
                  sd: l.sd || suite[deja].sd || '',
                };
              } else {
                n += 1;
                suite.push({
                  id: 'A' + n,
                  metier: detectMetier(l.d) || 'À classer',
                  nom: l.d,
                  u: l.u || 'forfait',
                  p: +l.p || 0,
                  sd: l.sd || '',
                  codeCan: '',
                });
              }
            }
            return suite;
          });
          window.alert(trf('✓ {0} article(s) ajouté(s) à tes articles.', lues.length));
        }}
      />
      {show && (
        <Card style={{ marginBottom: 11, border: '2px solid ' + C.navy }}>
          <Bar icon="➕" title="Nouvel article" color={C.navy} />
          <div style={{ padding: 13 }}>
            <div
              style={{
                fontSize: 8.5,
                fontWeight: 800,
                color: C.muted,
                textTransform: 'uppercase',
                marginBottom: 6,
              }}
            >
              Corps de métier — exemples (toucher pour pré-remplir)
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 7 }}>
              {BAT_PRESETS.map((g) => (
                <div
                  key={g.metier}
                  onClick={() => {
                    setPresetMet(presetMet === g.metier ? '' : g.metier);
                    setF((p) => ({ ...p, metier: tr(g.metier) }));
                  }}
                  style={{
                    padding: '5px 9px',
                    borderRadius: 8,
                    fontSize: 9,
                    fontWeight: 700,
                    cursor: 'pointer',
                    border: '1px solid ' + (presetMet === g.metier ? C.navy : C.border),
                    background: presetMet === g.metier ? C.navy : C.white,
                    color: presetMet === g.metier ? '#fff' : C.grey,
                  }}
                >
                  {tr(g.metier)}
                </div>
              ))}
            </div>
            {presetMet && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 11 }}>
                {((BAT_PRESETS.find((g) => g.metier === presetMet) || {}).arts || []).map(
                  (a, i) => (
                    <div
                      key={i}
                      onClick={() =>
                        setF((p) => ({
                          ...p,
                          metier: tr(presetMet),
                          nom: tr(a.nom),
                          u: a.u,
                          p: a.p,
                        }))
                      }
                      style={{
                        padding: '5px 9px',
                        borderRadius: 8,
                        fontSize: 9,
                        fontWeight: 600,
                        cursor: 'pointer',
                        border: '1px dashed ' + C.teal,
                        background: C.tealL,
                        color: C.teal,
                      }}
                    >
                      + {tr(a.nom)}
                    </div>
                  ),
                )}
              </div>
            )}
            <Inp
              label="Corps de métier (ex. Carreleur, Plombier…)"
              value={f.metier}
              onChange={(e) => setF((p) => ({ ...p, metier: e.target.value }))}
            />
            <Inp
              label="Nom de la prestation"
              value={f.nom}
              onChange={(e) => setF((p) => ({ ...p, nom: e.target.value }))}
            />
            <Inp
              label="Description / détail (facultatif)"
              rows={2}
              value={f.sd || ''}
              onChange={(e) => setF((p) => ({ ...p, sd: e.target.value }))}
            />
            <Inp
              label="Code CAN / NPK (facultatif, ex. 211.110)"
              value={f.codeCan || ''}
              onChange={(e) => setF((p) => ({ ...p, codeCan: e.target.value }))}
            />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div>
                <div
                  style={{
                    fontSize: 9,
                    fontWeight: 800,
                    color: C.muted,
                    textTransform: 'uppercase',
                    margin: '0 0 5px',
                  }}
                >
                  Unité
                </div>
                <select
                  value={f.u || 'forfait'}
                  onChange={(e) => setF((p) => ({ ...p, u: e.target.value }))}
                  style={{
                    width: '100%',
                    border: '1px solid ' + C.border,
                    borderRadius: 10,
                    padding: '11px 10px',
                    fontSize: 14,
                    background: '#fff',
                    boxSizing: 'border-box',
                  }}
                >
                  {UNITS_LIST.map((o) => (
                    <option key={o.v} value={o.v}>
                      {o.l}
                    </option>
                  ))}
                </select>
              </div>
              <Inp
                label={'Prix unitaire ' + DEVISE}
                type="text"
                inputMode="decimal"
                value={f.p}
                onChange={(e) => setF((p) => ({ ...p, p: e.target.value.replace(',', '.') }))}
                placeholder="0.00"
              />
            </div>
            <Btn
              label="✓ Ajouter au catalogue"
              color={C.navy}
              full
              disabled={!f.nom.trim()}
              onClick={add}
            />
          </div>
        </Card>
      )}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 7,
          paddingBottom: 6,
          marginBottom: 11,
        }}
      >
        <div
          onClick={() => setSelMet('')}
          style={{
            flex: '0 0 auto',
            whiteSpace: 'nowrap',
            padding: '8px 13px',
            borderRadius: 999,
            fontSize: 10,
            fontWeight: 700,
            cursor: 'pointer',
            border: '1px solid ' + (selMet === '' ? C.navy : C.border),
            background: selMet === '' ? C.navy : C.white,
            color: selMet === '' ? '#fff' : C.grey,
          }}
        >
          Tous
        </div>
        {metierChips.map((m) => (
          <div
            key={m}
            onClick={() => setSelMet(m)}
            style={{
              flex: '0 0 auto',
              whiteSpace: 'nowrap',
              padding: '8px 13px',
              borderRadius: 999,
              fontSize: 10,
              fontWeight: 700,
              cursor: 'pointer',
              border: '1px solid ' + (selMet === m ? C.navy : C.border),
              background: selMet === m ? C.navy : C.white,
              color: selMet === m ? '#fff' : C.grey,
            }}
          >
            {m}
          </div>
        ))}
      </div>
      {(catalogue || []).length > 0 && (
        <div style={{ marginBottom: 10 }}>
          <Btn
            label="🗑 Vider le catalogue"
            sm
            ghost
            color={C.red}
            full
            onClick={() => {
              if (window.confirm('Vider TOUT le catalogue de prestations ?'))
                setCatalogue && setCatalogue([]);
            }}
          />
        </div>
      )}
      {filtered.length === 0 && (
        <div style={{ textAlign: 'center', padding: 24, color: C.muted, fontSize: 11 }}>
          Aucune prestation
        </div>
      )}
      {metiers.map((m) => (
        <div key={m} style={{ marginBottom: 12 }}>
          <div
            style={{
              fontSize: 9,
              fontWeight: 800,
              color: C.muted,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
              marginBottom: 6,
            }}
          >
            {m}
          </div>
          {filtered
            .filter((a) => (a.metier || 'Autres') === m)
            .map((a) =>
              editId === a.id ? (
                <Card key={a.id} style={{ marginBottom: 6, border: '2px solid ' + C.navy }}>
                  <div style={{ padding: 13 }}>
                    <Inp
                      label="Corps de métier"
                      value={ef.metier}
                      onChange={(e) => setEf((p) => ({ ...p, metier: e.target.value }))}
                    />
                    <Inp
                      label="Nom de la prestation"
                      value={ef.nom}
                      onChange={(e) => setEf((p) => ({ ...p, nom: e.target.value }))}
                    />
                    <Inp
                      label="Description (facultatif)"
                      rows={2}
                      value={ef.sd || ''}
                      onChange={(e) => setEf((p) => ({ ...p, sd: e.target.value }))}
                    />
                    <Inp
                      label="Code CAN / NPK (facultatif)"
                      value={ef.codeCan || ''}
                      onChange={(e) => setEf((p) => ({ ...p, codeCan: e.target.value }))}
                    />
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                      <div>
                        <div
                          style={{
                            fontSize: 9,
                            fontWeight: 800,
                            color: C.muted,
                            textTransform: 'uppercase',
                            margin: '0 0 5px',
                          }}
                        >
                          Unité
                        </div>
                        <select
                          value={ef.u || 'forfait'}
                          onChange={(e) => setEf((p) => ({ ...p, u: e.target.value }))}
                          style={{
                            width: '100%',
                            border: '1px solid ' + C.border,
                            borderRadius: 10,
                            padding: '11px 10px',
                            fontSize: 14,
                            background: '#fff',
                            boxSizing: 'border-box',
                          }}
                        >
                          {UNITS_LIST.map((o) => (
                            <option key={o.v} value={o.v}>
                              {o.l}
                            </option>
                          ))}
                        </select>
                      </div>
                      <Inp
                        label={'Prix ' + DEVISE}
                        type="text"
                        inputMode="decimal"
                        value={ef.p}
                        onChange={(e) =>
                          setEf((p) => ({ ...p, p: e.target.value.replace(',', '.') }))
                        }
                        placeholder="0.00"
                      />
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <div style={{ flex: 1 }}>
                        <Btn
                          label="✓ Enregistrer"
                          sm
                          color={C.green}
                          full
                          onClick={() => {
                            setCatalogue &&
                              setCatalogue((p) =>
                                p.map((x) => (x.id === a.id ? { ...x, ...ef, p: +ef.p || 0 } : x)),
                              );
                            setEditId(null);
                          }}
                        />
                      </div>
                      <Btn
                        label="🗑"
                        sm
                        ghost
                        danger
                        color={C.red}
                        onClick={() => {
                          setCatalogue && setCatalogue((p) => p.filter((x) => x.id !== a.id));
                          setEditId(null);
                        }}
                      />
                      <Btn
                        label="Annuler"
                        sm
                        ghost
                        color={C.grey}
                        onClick={() => setEditId(null)}
                      />
                    </div>
                  </div>
                </Card>
              ) : (
                <Card
                  key={a.id}
                  style={{ marginBottom: 6, cursor: 'pointer' }}
                  onClick={() => {
                    setEf({
                      metier: a.metier,
                      nom: a.nom,
                      u: a.u,
                      p: a.p,
                      sd: a.sd || '',
                      codeCan: a.codeCan || '',
                    });
                    setEditId(a.id);
                  }}
                >
                  <div
                    style={{
                      padding: '10px 13px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ flex: 1, marginRight: 8 }}>
                      <div style={{ fontSize: 10.5, fontWeight: 700, color: C.ink }}>{a.nom}</div>
                      {a.sd && <div style={{ fontSize: 8, color: C.muted }}>{a.sd}</div>}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontSize: 11, fontWeight: 800, color: C.navy }}>
                        {DEVISE} {fmt(a.p)}
                      </span>
                      <span style={{ color: C.muted }}>✎</span>
                    </div>
                  </div>
                </Card>
              ),
            )}
        </div>
      ))}
    </Shell>
  );
}
